// Centralized content (real data pulled from veteransforindiana.com)

export const SITE = {
  name: "Veterans for Indiana",
  tagline: "Lead. Serve. Represent.",
  email: "info@veteransforindiana.com",
  emailDirector: "marlene@veteransforindiana.com",
  donateUrl: "https://secure.actblue.com/donate/vets4indiana",
  facebook: "https://www.facebook.com/profile.php?id=61558304451411",
  instagram: "https://www.instagram.com/veteransforindiana/",
  linkedin: "#",
  pacDisclaimer:
    "Paid for by Veterans for Indiana, PAC. © 2024 Veterans for Indiana. Tim Anderson, Treasurer.",
};

export const HERO_VIDEO = "/assets/hero.mp4";
export const HERO_POSTER = "/assets/hero-poster.jpg";
export const WWD_VIDEO = "/assets/wwd.mp4";
export const WWD_POSTER = "/assets/wwd-poster.jpg";

// Background image for the "Service Didn't End with the Uniform" donate banner.
// Reuses the hero poster (American flag frame) — locally hosted and instantly available.
export const DONATE_BANNER_IMG = "/assets/hero-poster.jpg";

// Real photos hosted on VFI's CDN (used directly)
export const TEAM = [
  {
    name: "David Galvin",
    title: "Chair",
    photo: "/assets/people/david.webp",
  },
  {
    name: "Tim Anderson",
    title: "Treasurer",
    photo: "/assets/people/tim.webp",
  },
  {
    name: "Marlene Julye",
    title: "Executive Director",
    photo: "/assets/people/marlene.webp",
  },
];

export const ADVISORY = [
  {
    name: "Brandon Sakbun",
    photo: "/assets/people/brandon.webp",
    bio: "Mayor of Terre Haute and U.S. Army Infantry Captain.",
  },
  {
    name: "Ed Delaney",
    photo: "/assets/people/ed.webp",
    bio: "Indiana State Representative for House District 86 and U.S. Navy Veteran.",
  },
  {
    name: "Lacy Johnson",
    photo: "/assets/people/lacy.webp",
    bio: "Attorney at Taft Stettinius & Hollister LLP, former Lt. Colonel with the Indiana State Police, and Lt. Commander in the U.S. Naval Intelligence Reserves.",
  },
  {
    name: "Martin Del Rio",
    photo: "/assets/people/martin.webp",
    bio: "National Capitol Region Coordinator for Operation Warfighter at Magellan Federal.",
  },
  {
    name: "Matt Hall",
    photo: "/assets/people/matt.webp",
    bio: "Veteran advocate, former Wayne Township Veterans Service Officer, and IU McKinney School of Law student.",
  },
  {
    name: "Renee Pack",
    photo: "/assets/people/renee.webp",
    bio: "Indiana State Representative for House District 92 and U.S. Army Veteran.",
  },
  {
    name: "Todd Connor",
    photo: "/assets/people/todd.webp",
    bio: "Co-Founder & CEO of Veterans for All Voters and founder of Bunker Labs.",
  },
  {
    name: "Travis Barnes",
    photo: "/assets/people/travis.webp",
    bio: "Marine Recon combat veteran and co-founder of Hotel Tango Artisan Distillery.",
  },
];

export const ENDORSEMENTS = [
  {
    name: "Destiny Wells",
    office: "Attorney General of Indiana",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/66ea2b5f6d38baeae3001d49_DWellsVFI.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-announces-endorsement-of-destiny-wells-for-attorney-general",
  },
  {
    name: "Matt McNally",
    office: "Indiana House District 39",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/66ea29a98deb26a237672593_MMcNallyVFI.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-matt-mcnally-for-indiana-house-district-39",
  },
  {
    name: "Thomas Horrocks",
    office: "Indiana House District 62",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/66f456ae48eb0850453f7387_THorrocksVFI.png",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-thomas-horrocks-for-indiana-house-district-62",
  },
  {
    name: "Robert Pope",
    office: "Indiana House District 40",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/66ead1938b637988ab25a219_RPope.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-robert-pope-for-indiana-house-district-40",
  },
  {
    name: "Tiffany Stoner",
    office: "Indiana Candidate",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/66eb73f6fe3647f436237187_TStoner.jpg",
    link: "https://www.veteransforindiana.com/news/tiffany-stoner-endorsed-by-veterans-for-indiana",
  },
  {
    name: "Nate Anderson",
    office: "Indiana House District 53",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/66ea2ce7453151b157002f14_NAndersonVFI.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-nate-anderson-for-indiana-house-district-53",
  },
  {
    name: "Blythe Potter",
    office: "Johnson County Council At-Large",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/66f45affa57850af4e19532a_BPotterVFI.png",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-blythe-potter-for-johnson-county-council-at-large",
  },
  {
    name: "Chuck Moseley",
    office: "Indiana House District 10",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/670431d26258cedf8f3944d2_CMoseleyVFI.png",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-chuck-moseley-for-indiana-hd10",
  },
  {
    name: "Ed Delaney",
    office: "Indiana House District 86",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/67053ed6a6268bd30aa97f7c_EDelaney.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-ed-delaney",
  },
  {
    name: "Mitch Gore",
    office: "Indiana State Representative",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/67068c19d1b8437606b399f0_MGoreVFI.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-is-proud-to-endorse-state-rep-mitch-gore",
  },
  {
    name: "Renee Pack",
    office: "Indiana House District 92",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/67068cec5f315764cdb0144a_RPackVFI.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-renee-pack",
  },
  {
    name: "Jennifer McCormick",
    office: "Governor of Indiana",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/670690bf0f925fbc5ca47d5f_JMcCormick.png",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-is-proud-to-endorse-jennifer-mccormick-for-governor",
  },
  {
    name: "Frank Islas",
    office: "Wayne Township Advisory Board",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/671163f0f20bb9b417048db8_FIslas.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-frank-islas-for-wayne-township-advisory-board",
  },
  {
    name: "Kirbie Young",
    office: "Hancock County Coroner",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/6711d36f18fe4746996284c8_KYoung.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-is-proud-to-endorse-kirbie-for-hancock-county-coroner",
  },
  {
    name: "Christine Glomb",
    office: "Indiana Candidate",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/671251fafc11fd3a24081d3b_CGlomb.jpg",
    link: "https://www.veteransforindiana.com/news/christine-glomb-endorsed-by-veterans-for-indiana",
  },
  {
    name: "Frank Rock",
    office: "Hancock County Council At-Large",
    photo:
      "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a0945/6714682d188a12cb892e6937_FRock.jpg",
    link: "https://www.veteransforindiana.com/news/veterans-for-indiana-endorses-frank-rock-for-hancock-county-at-large",
  },
];

export const ENDORSEMENTS_2026 = [
  {
    name: "Beau Bayh",
    office: "Indiana Secretary of State",
    photo: "/assets/endorsements-2026/beau-bayh.webp",
    link: "https://beaubayh.com/",
  },
  {
    name: "Racheal Bleicher",
    office: "Indiana House District 24",
    photo: "/assets/endorsements-2026/racheal-bleicher.webp",
    link: "https://www.rachealforindiana.com/",
  },
  {
    name: "Tiffany Stoner",
    office: "Indiana House District 25",
    photo: "/assets/endorsements-2026/tiffany-stoner.webp",
    link: "https://www.tiffanystoner.com/",
  },
  {
    name: "Ryan Kominakis",
    office: "Indiana House District 4",
    photo: "/assets/endorsements-2026/ryan-kominakis.webp",
    link: "https://www.ryankominakis.com/",
  },
  {
    name: "Pepper Snyder",
    office: "Indiana House District 50",
    photo: "/assets/endorsements-2026/pepper-snyder.webp",
    link: "https://peopleforpepper.com/",
  },
  {
    name: "Jeff Greenwell",
    office: "Posey County Council",
    photo: "/assets/endorsements-2026/jeff-greenwell.webp",
    link: "https://www.facebook.com/share/1CJKMWWm5X/",
  },
  {
    name: "Jon Wogenstahl",
    office: "Center Township Trustee",
    photo: "/assets/endorsements-2026/jon-wogenstahl.webp",
    link: "https://www.facebook.com/share/1Pz9CuFBkq/",
  },
  {
    name: "Joe Weingarten",
    office: "Fall Creek Township",
    photo: "/assets/endorsements-2026/joe-weingarten.webp",
    link: "https://www.facebook.com/share/19YSqNawpf/",
  },
];

export const NEWS = [
  {
    title: "Statement on U.S. Military Action Against Iran",
    date: "May 20, 2026",
    excerpt:
      "Veterans for Indiana is deeply concerned by reports of large-scale U.S. military operations against Iran without Congressional authorization. As veterans, we understand the cost of war — not in headlines, but in lives.",
    link: "https://www.veteransforindiana.com/news/statement-on-u-s-military-action-against-iran",
  },
];

export const HERO_IMAGE =
  "https://cdn.prod.website-files.com/6619cd1e3697523c7c9a093d/665f610fd583cac86a11fbbe_VeteranImage.svg";
